export let KnowledgeBaseLinks;
(function (KnowledgeBaseLinks) {
  KnowledgeBaseLinks["INBOX_SLA"] = "https://knowledge.hubspot.com/inbox/set-slas-in-the-inbox";
})(KnowledgeBaseLinks || (KnowledgeBaseLinks = {}));